import { useTranslation } from "react-i18next";

import { Alert } from "@mui/material";

export function NotFullyPaidWarning() {
  const { t } = useTranslation();

  return (
    <Alert severity="error" icon={false}>
      {t("clients.client.debtSettlement.assetInventory.dependants.notFullyPaidWarning")}
    </Alert>
  );
}
